export default
{
	PENDING_START: 'pendingStart',
	OPEN: 'open',
	CLOSED: 'closed',
	SUSPENDED: 'suspended'
};